<kendo-tabstrip #tabstrip>
    <kendo-tabstrip-tab title="{{ 'DIRECTORY-SEARCH' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
            <form novalidate [formGroup]="searchForm" class="k-form mb-3" (keydown)="keyDown($event)"
                style="overflow: hidden;" *ngIf="loaded">
                <div class="row reduced-search-criteria-margin reduced-custom">
                    <div class="col-3">
                        <label class="k-form-field">
                            <span class="k-text-uppercase dark">
                                {{'PROVIDER-FIRST-NAME' | translate}}
                            </span>
                            <input id="firstName" kendoTextBox formControlName="firstName" class="d-flex" />
                        </label>
                    </div>
                    <div class="col-3">
                        <label class="k-form-field">
                            <span class="k-text-uppercase dark">
                                {{'PROVIDER-LAST-NAME' | translate}}
                            </span>
                            <input id="lastName" kendoTextBox formControlName="lastName" class="d-flex" />
                        </label>
                    </div>
                    <div class="col-3">
                        <label class="k-form-field">
                            <span class="k-text-uppercase dark">
                                {{'ORGANIZATION-NAME' | translate}}
                            </span>
                            <input id="lastName" kendoTextBox formControlName="organizationName" class="d-flex" />
                        </label>
                    </div>
                    <div class="col-3">
                    </div>
                </div>
                <div class="row reduced-search-criteria-margin reduced-custom">
                    <div class="col-3">
                        <label class="k-form-field">
                            <span class="k-text-uppercase dark">
                                {{'CITY' | translate}}
                            </span>
                            <input id="lastName" kendoTextBox formControlName="city" class="d-flex" />
                        </label>
                    </div>
                    <div class="col-3">
                        <label class="k-form-field">
                            <span class="k-text-uppercase dark">
                                {{'STATE' | translate}}
                            </span>
                            <kendo-combobox class="w-100" id="state" formControlName="state" [data]="states"
                                [valuePrimitive]="true" [textField]="'displayName'" [valueField]="'code'"
                                class="d-flex">
                            </kendo-combobox>
                        </label>
                    </div>
                    <div class="col-3">
                        <label class="k-form-field">
                            <span class="k-text-uppercase dark">
                                {{'POSTAL-CODE' | translate}}
                            </span>
                            <input id="zip" kendoTextBox formControlName="zip" class="w-flex" />
                        </label>
                    </div>
                    <div class="col-3">
                        <button kendoButton type="button" (click)="searchDirectory(true)">
                            {{'SEARCH' | translate}}<i class="far fa-search"></i>
                        </button>
                        <i class="fas fa-fw fa-times-circle fa-delete-custom ml-2 pt-0"
                            title="{{'SEARCH-CLEAR-ALL' | translate}}" [hidden]="clearHidden()" tabindex="0"
                            (keydown.enter)="clearSearchForm()" (keydown.space)="clearSearchForm()"
                            (click)="clearSearchForm()" style="font-size:20pt;position: relative;top: 6px;">
                        </i>
                    </div>
                </div>
                <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)" class="mt-2"
                    style="margin-left:-10px;margin-right:-10px">
                    <kendo-tabstrip-tab title="{{ 'PROVIDERS' | translate }} {{getProviderCount(totalProvidersCount)}}"
                        [selected]="true">
                        <ng-template kendoTabContent>
                            <ng-template [ngTemplateOutlet]="directoryGridTemplate"
                                [ngTemplateOutletContext]="{gridData:dataProviders, keys: selectedProviders, propName: 'selectedProviders'}">
                            </ng-template>
                        </ng-template>
                    </kendo-tabstrip-tab>
                    <kendo-tabstrip-tab *ngIf="showOrganizationsTab"
                        title="{{ 'ORGANIZATIONS' | translate }} {{getProviderCount(totalOrganizationsCount)}}">
                        <ng-template kendoTabContent>
                            <ng-template [ngTemplateOutlet]="directoryGridTemplate"
                                [ngTemplateOutletContext]="{gridData:dataOrganizations, keys: selectedOrganizations, propName: 'selectedProviders'}">
                            </ng-template>
                        </ng-template>
                    </kendo-tabstrip-tab>
                </kendo-tabstrip>
            </form>
        </ng-template>
    </kendo-tabstrip-tab>
</kendo-tabstrip>

<!--Grid Template-->
<ng-template #directoryGridTemplate let-gridData='gridData' let-keys='keys' let-tabIndex='tabIndex'
    let-propName='propName'>
    <kendo-grid id="provider-search" [data]="gridData | async" [loading]="loading"
        (scrollBottom)="searchDirectory(false)" class="mt-2 mb-2" [resizable]="true" [selectedKeys]="keys"
        [kendoGridSelectBy]=""
        [selectable]="{ mode: (singleSelectionOnly ? 'single' : 'multiple'), checkboxOnly: true }"
        (selectedKeysChange)="onSelectedKeysChange($event, propName)">
        <kendo-grid-checkbox-column [columnMenu]="false" [width]="40" *ngIf="allowSelection" class="text-center"
            headerClass="text-center">
        </kendo-grid-checkbox-column>
        <kendo-grid-messages noRecords="{{ 'NO-PROVIDERS' | translate }}">
        </kendo-grid-messages>
        <kendo-grid-column field="lastName" title="{{'NAME' | translate}}">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div class="ellipsis-text" title="{{getProviderName(dataItem)}}">
                    {{getProviderName(dataItem)}}
                </div>
                <div *ngIf="dataItem.directAddress" class="directAddress montserrat ellipsis-text"
                    title="{{dataItem.directAddress}}">
                    <i class="fas fa-copy mr-1" style="font-size: initial; cursor: pointer;"
                        title="{{'COPY' | translate}}" (click)="copyDirectAddress(dataItem.directAddress)">
                    </i>&nbsp;{{dataItem.directAddress}}
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="standardizedAddressLine1" title="{{'ADDRESS' | translate}}">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngIf="dataItem.clinicName">{{dataItem.clinicName}}</div>
                <div *ngIf="dataItem.standardizedAddressLine1">{{dataItem.standardizedAddressLine1}}</div>
                <div>{{dataItem.standardizedCity}}, {{dataItem.standardizedState}}&nbsp;{{dataItem.standardizedZip}}
                </div>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</ng-template>